import { Modal, ModalDrawer, Typography, OverflowContainer, Box, IconButton } from "@husqvarna/ui-core";
import { FormattedMessage, useIntl } from "react-intl";
import "./index.scss";

export type InfoDrawerProps = {
  isOpen: boolean;
  onClosing?: () => void;
};

const InfoDrawer = ({
  isOpen = false,
  onClosing = () => {}
}: InfoDrawerProps) => {
  const intl = useIntl();

  return (
    <Modal active={isOpen}>
      <ModalDrawer className="tcsp-info" anchor="right">
        <IconButton className="tcsp-project__dialog-close" icon="close" onClick={() => onClosing?.()} />
        <OverflowContainer direction="vertical" fadeOut="mask">
          <Box mx={20} my={12}>
            <Typography variant="Heading4" tag="h4" mt={12} mb={8}>
              <FormattedMessage id="infoDrawer.title" defaultMessage="About" />
            </Typography>
            <Typography variant="Body2" tag="h4" mt={7} mb={5}>
              <FormattedMessage id="infoDrawer.version" defaultMessage="Version: 3.0.0" />
            </Typography>
            <Box>
              <Typography>
                <FormattedMessage id="infoDrawer.paragraph1"
                values={{ br: <br />, b: (chunks) => <strong>{chunks}</strong> }}
                defaultMessage="The Turf Care Site Planner, or TCSP, is a tool that aims to facilitate our internal sales force and PRO Partner by improving the more complicated aspects of the sales process for Professional Automower/CEORA. By <b>saving time</b> throughout the sales process while doing so in a <b>premium digital context</b>, it aims to <b>improve sales efficiency.</b>"/>
              </Typography>
            </Box>
            <Box mt={8}>
              <Typography variant="Subtitle2" tag="h5">
                <FormattedMessage id="infoDrawer.userGroupsTitle" defaultMessage="User groups" />
              </Typography>
              <Typography tag="p" mt={2}>
                <FormattedMessage id="infoDrawer.userGroupsDescription"
                  defaultMessage="Key accounts and partners/Pro dealers managing Pro Robotics and CEORA sales."
                />
              </Typography>
            </Box>
            <Box mt={8}>
              <Typography variant="Subtitle2" tag="h5" mb={2}>
                <FormattedMessage id="infoDrawer.userGoalsTitle" defaultMessage="User goals we build this around" />
              </Typography>
              <Typography variant="Body1">
                <ul>
                  <li><FormattedMessage id="infoDrawer.userGoal.saveTime" defaultMessage="Save time during prospecting." /></li>
                  <li><FormattedMessage id="infoDrawer.userGoal.understandCoverage" defaultMessage="Understand the number of machines needed to cover their customers' sites." /></li>
                  <li><FormattedMessage id="infoDrawer.userGoal.understandReturnOfInvestment" defaultMessage="Understand the ROI moving from current mower setup to a Husqvarna autonomous fleet." /></li>
                  <li><FormattedMessage id="infoDrawer.userGoal.accuracy" defaultMessage="Be accurate when calculating the machine coverage for prospect needs." /></li>
                </ul>
              </Typography>
            </Box>
            <Box mt={8}>
              <Typography variant="Subtitle2" tag="h5">
                <FormattedMessage id="infoDrawer.suggenstionTitle" defaultMessage="Do you have questions or feedback?" />
              </Typography>
              <Typography tag="p" mt={2}>
                <FormattedMessage id="infoDrawer.suggestionDescription"
                  values={{
                    br: <br />,
                    contactLink: (chunks) => <a target="_blank" className="tcsp-info-link" href={intl.formatMessage({id: "header.feedbackLink", defaultMessage: "https://hsq-prod.husqvarnagroup.com/TurfCarePlannerFeedbackInputForm/"})} rel="noreferrer">
                      {chunks}
                    </a>,
                  }}
                  description="Add a <contactLink>-tag around text to make it a link to the maze-form (defined in header.feedbackLink). Also {br} adds  a row break"
                  defaultMessage="Please use the <contactLink>contact form or feedback form</contactLink> located in the top right corner. Your input and feedback are important for our development.{br}{br}"
                />
              </Typography>
            </Box>
          </Box>
        </OverflowContainer>
      </ModalDrawer>
    </Modal>
  );
}

export default InfoDrawer;
